import { render, staticRenderFns } from "./AwsFilePreviewModal.vue?vue&type=template&id=bbeebe60"
import script from "./AwsFilePreviewModal.vue?vue&type=script&lang=ts"
export * from "./AwsFilePreviewModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbeebe60')) {
      api.createRecord('bbeebe60', component.options)
    } else {
      api.reload('bbeebe60', component.options)
    }
    module.hot.accept("./AwsFilePreviewModal.vue?vue&type=template&id=bbeebe60", function () {
      api.rerender('bbeebe60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aws-files-modules/AwsFilePreviewModal.vue"
export default component.exports